
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: 0,
    }
  },
  methods: {
    activeItem(index) {
      this.show = index
    },
  },
}
